import { createAsyncThunk } from "@reduxjs/toolkit"
import { flushSync } from "react-dom"
import { store } from "../../../store"
import { 
  uploadCaseFilesByFileNames,
  deleteCaseFiles
} from "../clinicalThunkApi"
import {
  updateCaseById,
} from "@/core/app/slices/case/caseThunkApi"
import {
  setRefinementReady
} from "../clinicalSlice"
import {
  setOpenInitialFinal,
  setOpenGrid,
  setIsCreateNewRefinement,
  setIsCreateSelfplanRefinement,
  setStageShowType,
} from "@/UDTreat/udTreatSlice"

import {
  getRefinementType,
} from "../clinical.types"
import {
  downloadRefinementFile
} from "../clinical.service"

import {
  caseManagement,
  treatView,
  refinement,
  viewControlInTreatment
} from "@/gluelayer"


export const fetchRefinementJsonFile = createAsyncThunk(
  "clinicalService/fetchRefinementJsonFile",
  async (
    { patientId, caseId, refinementFiles }: getRefinementType,
    { rejectWithValue, getState },
  ) => {
    const orgId = (getState() as any).userService.user.current_orgId
    try {
      return await downloadRefinementFile({ orgId, patientId, caseId, refinementFiles})
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const fetchRefinementZipFile = createAsyncThunk(
  "clinicalService/fetchRefinementZipFile",
  async (
    { patientId, caseId, refinementFiles }: getRefinementType,
    { rejectWithValue, getState },
  ) => {
    const orgId = (getState() as any).userService.user.current_orgId
    try {
      return await downloadRefinementFile({ orgId, patientId, caseId, refinementFiles})
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)


// Open creating refinement workflow
export const openRefinement = createAsyncThunk(
  "refinement/openRefinement",
  async (
    { isSelfplan=false } : {isSelfplan:boolean},
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      viewControlInTreatment.setViewType("front")
      const dispatch = store.dispatch
      await dispatch(setOpenInitialFinal(false))
      flushSync(() => setOpenGrid(false))
      treatView.startSplitScreenToCreateRefinement()
      dispatch(setIsCreateNewRefinement(true))
      if (isSelfplan) {
        dispatch(setIsCreateSelfplanRefinement(true))
      }
      dispatch(setStageShowType("compare"))
    } catch (err) {
      console.warn("Something wrong in conversion case ...,", err);
      return rejectWithValue(err)
    }
  }
)

/**
 * Fetch last refinement data from server.
 */
export const fetchLastRefinementData = createAsyncThunk(
  "refinement/fetchLastRefinementData",
  async (
    { caseId, patientId }: any,
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      const dispatch = store.dispatch
      const folderName = refinement.getLastRefinementName()

      let refinementFiles = []
      let refinementZipFolderNames = []
      const isExisted = caseManagement.IsRefinementItemExisted(folderName)
      if (isExisted == false) {
        refinementZipFolderNames.push(folderName)
        refinementFiles.push(folderName + ".zip")
        const r = await dispatch(
          fetchRefinementZipFile({
            orgId: "",
            patientId,
            caseId,
            refinementFiles,
          }),
        )
        const { payload } = r
        let refinementZips: object = []
        for (let i = 0; i < (payload as []).length; i++) {
          refinementZips["RetouchHistoryZip" + i] = payload[i].data
        }
        await caseManagement
          .AddARefinementHistory(
            refinementZipFolderNames,
            refinementZips as Record<string, Blob>,
          )
      }
    } catch (err) {
      console.warn("Something wrong in fetch refinement data ...,", err);
      return rejectWithValue(err)
    }
  }
)

/**
 * undoRefinement
 */
export const undoRefinement = createAsyncThunk(
  "refinement/undoRefinement",
  async (
    { caseId, patientId,lockFunc }: any,
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      const dispatch = store.dispatch
      
      //console.log('undo refinement finished00000',(getState() as any).udTreatService.refinementNum);

      dispatch(setRefinementReady(false))
      // open refinement dialog
      await dispatch(
        fetchLastRefinementData({
          caseId,
          patientId,
        }),
      )
      refinement.undoRefinement();

      // update refinement-ready status to notify update the refinementNum.
      await dispatch(setRefinementReady(true))

      // await new Promise((resolve)=>lockFunc(async ()=>{
      //   await dispatch(uploadCaseFilesByFileNames({
      //     patientId,
      //     caseId,
      //     fileNames: ["bulk0.zip","bulk1.zip","bulk2.zip","bulk10.zip","raw.zip","photo.zip","RetouchHistory.json"],
      //   }))

      //   await dispatch(openRefinement({
      //     isSelfplan: true,
      //   }))
      //   resolve(true)
      // }))
      await dispatch(uploadCaseFilesByFileNames({
        patientId,
        caseId,
        fileNames: ["bulk0.zip","bulk1.zip","bulk2.zip","bulk10.zip","raw.zip","photo.zip","RetouchHistory.json"],
      }))

      await dispatch(openRefinement({
        isSelfplan: true,
      }))


      // clear photos
      // console.log('clearing previous refinement file type.json');
      const { refinementNum } = (getState() as any).udTreatService
      await dispatch(deleteCaseFiles({patientId,caseId,fileNames:[`type${refinementNum}.json`]}))

      // update refinement course check number
      await dispatch(
        updateCaseById({
          patientId,
          caseId,
          payload: {
            course_check_number: refinementNum - 1,
          },
        }),
      )


    } catch (err) {
      console.warn("Something wrong in undo refinement ...,", err);
      return rejectWithValue(err)
    }
  }
)